import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = () => {
  const userName = process.env.REACT_APP_USERNAME;
  return (
    // <!-- ========== Start Navbar ========== -->

    <div className="vertical-nav demo2">
      {/* <!-- Logo --> */}
      {/* <a className="logo" href="/">A</a> */}
      <NavLink className="logo" to='/' >{userName.charAt()}</NavLink>
      {/* <!-- Toggle Menu --> */}
      <button className="toggle-menu">
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
      {/* <!-- Mini Menu --> */}
      <div className="mini-menu">
        <ul className="list-unstyled">
          <li><NavLink to='/home' ><i className="flaticon-door"></i><span>Home</span></NavLink></li>
          <li><NavLink to="/about" ><i className="flaticon-icon"></i><span>About</span></NavLink></li>
          <li><NavLink to='/resume' ><i className="flaticon-leaf"></i><span>Resume</span></NavLink></li>
          <li><NavLink to='/portfolio' ><i className="flaticon-squares"></i><span>Works</span></NavLink></li>
           {/* <li><NavLink to='/code' ><i className="fa fa-code menu-custon-icon"></i><span>Source</span></NavLink></li> */}
          {/* <li><NavLink to='/blogs' ><i className="flaticon-blogging"></i><span>Blog</span></NavLink></li> */}
          <li><NavLink to='/contact' ><i className="fa fa-phone"></i><span>Contact</span></NavLink></li>
        </ul>
      </div>
    </div>

    // <!-- ========== End Navbar ========== -->

  );
}

export { Navigation };
